import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiConfigs } from "../../constants/apiConfigs";
import { Insights } from "../../types/influencer/insightsTypes"
import { isFresh } from "../../utils/helpers";
import { ERROR } from "../../constants/errors";
import { fetchInsights } from "../../services/api/influencer";

export interface InfluencerInsightsSlice {
    last_fetched_at: number | null
    expired: boolean,
    loading: boolean,
    data: Insights | null
}

export const initialState: InfluencerInsightsSlice = {
    data: null,
    last_fetched_at: null,
    expired: false,
    loading: false
}

const STALE_TIME = apiConfigs.FETCH_WALLET.staleTime;

export const fetchInfluencerInsightsData = createAsyncThunk(
    'influencer/insights',
    async (force: boolean, {getState, rejectWithValue}) => {
        const state = getState() as {influencerInsights: InfluencerInsightsSlice};
        if(!force && isFresh(state.influencerInsights.last_fetched_at, STALE_TIME) && !state.influencerInsights.expired){
            return rejectWithValue(ERROR.CACHED);
        }

        try {
            const insightsData = await fetchInsights();
            return insightsData;
        } catch (error: any) {
            return rejectWithValue(ERROR.NOT_FOUND);
        }

    }
)

const influencerInsightsSlice = createSlice({
    name: 'influencerInsights',
    initialState,
    reducers: {
        markExpired: (state) => {
            state.expired = true;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchInfluencerInsightsData.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchInfluencerInsightsData.fulfilled, (state, data) => {
                state.loading = false;
                state.last_fetched_at = Date.now();
                state.expired = false;
                state.data = data.payload;
            })
            .addCase(fetchInfluencerInsightsData.rejected, (state, data) => {
                state.loading = false;
            })
    }
})

export const {markExpired} = influencerInsightsSlice.actions;

export default influencerInsightsSlice.reducer;